// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3URHB","error":"Textarea_error__TYMSw","readonly":"Textarea_readonly__2Whu1","disabled":"Textarea_disabled__czmM7"};